import React from 'react'

import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Icon } from '@iconify/react'

const MerchModal = ({ attributes, setIsMerchModalOpen, addToCart, isCartOpen }) => {

    const { title, description, price, collection, modelImage } = attributes

    const setSize = (size) => {
        return attributes.size = size
    }

    return (
        <div className={`columns is-vcentered ${isCartOpen ? 'merch-modal-open-cart' : 'merch-modal'}`}>
            <div className="column">
            <GatsbyImage image={getImage(modelImage)} alt="image of merch" />
            </div>
            <div className="column" id="info">
                { !isCartOpen && <Icon icon="fontisto:close-a" color="#d6b455" className="is-size-1 hover merch-modal-close-btn"
                            onClick={() => setIsMerchModalOpen(false)} onKeyDown={() => setIsMerchModalOpen(false)}
                            role="button" tabIndex={-1}
                        />
                }
                <div className="my-3">
                    <p className="is-size-5">Title</p>
                    <p className="is-size-4">{title}</p>
                </div>

                <div className="my-3">
                    <p className='is-size-5'>Description</p>
                    <p className="is-size-4">{description}</p>
                </div>

                <div className="my-3">
                    <p className='is-size-5'>Collection</p>
                    <p className="is-size-4">{collection}</p>
                </div>

                <div className="my-3">
                    <p className='is-size-5'>Price</p>
                    <p className="is-size-4">₦{price}</p>
                </div>

                <div className='my-3'>
                    <p className='is-size-5'>Size</p>
                    { console.log(attributes.size) }
                    {
                        attributes.size ?
                            <p className="is-size-4">{attributes.size}</p>
                            :
                            <select onChange={(e) => setSize(e.target.value)} className="is-size-5 py-1" style={{width: '50%'}}>
                                <option value={undefined}>-</option>
                                <option value="XS">XS</option>
                                <option value="S">S</option>
                                <option value="M">M</option>
                                <option value="L">L</option>
                                <option value="XL">XL</option>
                            </select>
                    }
                </div>

                { !isCartOpen && 
                    <button className="buton is-size-3 merch-button mt-3" 
                        onClick={() => { addToCart(attributes); setIsMerchModalOpen(false)}}>Add
                    </button> 
                }
            </div>
        </div>
    )
}

export default MerchModal
